/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleUnlockedBySameAdmin: {
		id: 'eoc-changeboarding.wizard.steps.five.title-unlocked-by-same-admin.no-translate',
		defaultMessage: 'Started your shift from Opsgenie to Jira',
		description: 'Title of step five',
	},
	titleUnlockedByAnotherAdmin: {
		id: 'eoc-changeboarding.wizard.steps.five.title-unlocked-by-another-admin.no-translate',
		defaultMessage: 'Your work from Opsgenie is shifting to Jira',
		description: 'Title of step five',
	},
	titleByUser: {
		id: 'eoc-changeboarding.wizard.steps.five.title-by-user.no-translate',
		defaultMessage: 'Your work from Opsgenie is shifting to Jira',
		description: 'Title of step five',
	},
	listDescription: {
		id: 'eoc-changeboarding.wizard.steps.five.list-description.no-translate',
		defaultMessage:
			'Almost all of your Opsgenie data and settings are now in Jira Service Management.',
		description: 'Description of list that contains what will happen after unlocking operations',
	},
	listDescriptionTwo: {
		id: 'eoc-changeboarding.wizard.steps.five.list-description-two.no-translate',
		defaultMessage:
			'Let’s go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management.',
		description: 'Description of list that contains what will happen after unlocking operations',
	},
	listItemHeading: {
		id: 'eoc-changeboarding.wizard.steps.five.list-item-heading.no-translate',
		defaultMessage: 'Let’s go set up a few things so your team can get started',
		description: 'Description of list items',
	},
	listDescriptionForAnotherAdmin: {
		id: 'eoc-changeboarding.wizard.steps.five.list-description-for-another-admin.no-translate',
		defaultMessage:
			'Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work.',
		description:
			'Description of list that contains what will happen after unlocking operations, different admin variant. Also see eoc-changeboarding.wizard.steps.five.list-description',
	},
	listItemOne: {
		id: 'eoc-changeboarding.wizard.steps.five.list-item-one.no-translate',
		defaultMessage: 'Configure chat integrations in Jira Service Management',
		description: 'List item that indicates that Opsgenie data will be copied without changes',
	},
	listItemTwo: {
		id: 'eoc-changeboarding.wizard.steps.five.list-item-two.no-translate',
		defaultMessage:
			'Give the product admin role to {userAmount, plural, one {{userAmount} Opsgenie admin} other {{userAmount} Opsgenie admins}}',
		description: 'List item that indicates that Opsgenie account will still be accessible',
	},
	listItemThree: {
		id: 'eoc-changeboarding.wizard.steps.five.list-item-three.no-translate',
		defaultMessage:
			'Give a product role to {userAmount, plural, one {{userAmount} Opsgenie user} other {{userAmount} Opsgenie users}} who no longer have a custom role',
		description: 'List item that indicates that you will get help to set up and get started',
	},
	listItemOneUser: {
		id: 'eoc-changeboarding.wizard.steps.five.list-item-one-user.no-translate',
		defaultMessage: 'Configure your notifications settings in Jira',
		description: 'List item that indicates that Opsgenie data will be copied without changes',
	},
	listItemTwoUser: {
		id: 'eoc-changeboarding.wizard.steps.five.list-item-two-user.no-translate',
		defaultMessage: 'Discover how operations works on Jira Service Management',
		description: 'List item that indicates that Opsgenie account will still be accessible',
	},
	learnMore: {
		id: 'eoc-changeboarding.wizard.steps.five.learn-more.no-translate',
		defaultMessage: 'Don’t feel ready yet? <link>Read more about operations</link>',
		description: 'Link to learn more about operations',
	},
});
